// @ts-expect-error - TS2614 - Module '"src/api-parsers"' has no exported member 'Workflow'. Did you mean to use 'import Workflow from "src/api-parsers"' instead?
import type {Workflow} from 'src/api-parsers';
import type {WorkflowAction} from 'src/action-creators/workflows';
import type {EntityType} from 'src/types/ats-entities';
import type {BusinessGoals} from 'src/types/workflow';

import keyBy from 'lodash/keyBy';

import {
  RECEIVE_ALL,
  UPDATE,
  BULK_UPDATE_WORKFLOWS,
  DELETE_WORKFLOW,
  RECEIVE_ENTITY_TYPES,
  RECEIVE_BUSINESS_GOALS,
  RECEIVE_RECIPIENT_TYPES,
  RECEIVE_WORKFLOW,
} from 'src/action-creators/workflows';


export type WorkflowState = {
  workflows: {
    [workflowId: string]: Workflow;
  };
  workflowsWithEvents: {
    [workflowId: string]: Workflow;
  };
  // the entity types supported across all workflows
  entityTypes: EntityType[];
  businessGoals?: BusinessGoals[];
  // recipient allowed for each workflowId
  recipientTypes: {
    [workflowId: string]: string[];
  };
};

const initialState = {
  workflows: Object.freeze({}),
  entityTypes: Object.freeze([]),
  recipientTypes: Object.freeze({}),
  workflowsWithEvents: Object.freeze({}),
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly workflows: Readonly<{}>; readonly entityTypes: readonly never[]; readonly recipientTypes: Readonly<{}>; readonly workflowsWithEvents: Readonly<{}>; }' is not assignable to type 'WorkflowState'.
  state: WorkflowState | null | undefined = initialState,
  action: WorkflowAction,
): WorkflowState => {
  switch (action.type) {
    case RECEIVE_ALL:
      // @ts-expect-error - TS2322 - Type '{ workflows: { [x: string]: any; }; workflowsWithEvents?: { [workflowId: string]: Workflow; } | undefined; entityTypes?: EntityType[] | undefined; businessGoals?: BusinessGoals[]; recipientTypes?: { ...; } | undefined; }' is not assignable to type 'WorkflowState'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        workflows: {...state.workflows, ...keyBy(action.payload, 'id')},
      };
    case UPDATE: {
      const {workflowId, update} = action.payload;
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      const currentWorkflow = state.workflows[workflowId];
      // @ts-expect-error - TS2322 - Type '{ workflows: { [x: string]: any; }; workflowsWithEvents: { [x: string]: any; }; entityTypes?: EntityType[] | undefined; businessGoals?: BusinessGoals[]; recipientTypes?: { [workflowId: string]: string[]; } | undefined; }' is not assignable to type 'WorkflowState'.
      return {
        ...state,
        workflows: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.workflows,
          [workflowId]: {
            ...currentWorkflow,
            ...update,
          },
        },
        workflowsWithEvents: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.workflowsWithEvents,
          [workflowId]: {
            ...currentWorkflow,
            ...update,
          },
        },
      };
    }
    case BULK_UPDATE_WORKFLOWS: {
      // @ts-expect-error - TS2322 - Type '{ workflows: { [x: string]: any; }; workflowsWithEvents: { [x: string]: any; }; entityTypes?: EntityType[] | undefined; businessGoals?: BusinessGoals[]; recipientTypes?: { [workflowId: string]: string[]; } | undefined; }' is not assignable to type 'WorkflowState'.
      return {
        ...state,
        workflows: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.workflows,
          ...Object.keys(action.payload).reduce<Record<string, any>>(
            (acc, workflowId) => {
              const update = action.payload[workflowId];
              // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
              const current = state.workflows[workflowId];
              acc[workflowId] = {...current, ...update};
              return acc;
            },
            {},
          ),
        },
        workflowsWithEvents: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.workflowsWithEvents,
          ...Object.keys(action.payload).reduce<Record<string, any>>(
            (acc, workflowId) => {
              const update = action.payload[workflowId];
              // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
              const current = state.workflows[workflowId];
              acc[workflowId] = {...current, ...update};
              return acc;
            },
            {},
          ),
        },
      };
    }
    case RECEIVE_WORKFLOW: {
      // @ts-expect-error - TS2322 - Type '{ workflows: { [x: string]: any; }; workflowsWithEvents: { [x: string]: any; }; entityTypes?: EntityType[] | undefined; businessGoals?: BusinessGoals[]; recipientTypes?: { [workflowId: string]: string[]; } | undefined; }' is not assignable to type 'WorkflowState'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        workflows: {...state.workflows, ...keyBy(action.payload, 'id')},
        workflowsWithEvents: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.workflowsWithEvents,
          ...keyBy(action.payload, 'id'),
        },
      };
    }
    case DELETE_WORKFLOW:
      const {[action.payload.id]: _removedWorkflow, ...newWorkflows} =
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        state.workflows;
      // @ts-expect-error - TS2322 - Type '{ workflows: { [workflowId: string]: Workflow; }; workflowsWithEvents?: { [workflowId: string]: Workflow; } | undefined; entityTypes?: EntityType[] | undefined; businessGoals?: BusinessGoals[]; recipientTypes?: { ...; } | undefined; }' is not assignable to type 'WorkflowState'.
      return {...state, workflows: newWorkflows};
    case RECEIVE_ENTITY_TYPES:
      // @ts-expect-error - TS2322 - Type '{ entityTypes: EntityType[]; workflows?: { [workflowId: string]: Workflow; } | undefined; workflowsWithEvents?: { [workflowId: string]: Workflow; } | undefined; businessGoals?: BusinessGoals[]; recipientTypes?: { ...; } | undefined; }' is not assignable to type 'WorkflowState'.
      return {...state, entityTypes: action.payload};
    case RECEIVE_BUSINESS_GOALS:
      // @ts-expect-error - TS2322 - Type '{ businessGoals: BusinessGoals[]; workflows?: { [workflowId: string]: Workflow; } | undefined; workflowsWithEvents?: { [workflowId: string]: Workflow; } | undefined; entityTypes?: EntityType[] | undefined; recipientTypes?: { ...; } | undefined; }' is not assignable to type 'WorkflowState'.
      return {...state, businessGoals: action.payload};
    case RECEIVE_RECIPIENT_TYPES:
      // @ts-expect-error - TS2322 - Type '{ recipientTypes: { [x: string]: string[]; }; workflows?: { [workflowId: string]: Workflow; } | undefined; workflowsWithEvents?: { [workflowId: string]: Workflow; } | undefined; entityTypes?: EntityType[] | undefined; businessGoals?: BusinessGoals[]; }' is not assignable to type 'WorkflowState'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        recipientTypes: {...state.recipientTypes, ...action.payload},
      };
  }

  // @ts-expect-error - TS2322 - Type 'WorkflowState | null' is not assignable to type 'WorkflowState'.
  return state;
};
